import { observer } from "mobx-react"
import { playerStore } from "../../../store/player.store"
import { useEffect, useState } from "react"

const HomeScreen = observer(() => {
  const [isMob] = useState(window.innerWidth < 1024)
  const [opacity, setOpacity] = useState(1)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (playerStore.isPlayerClick) {
      setOpacity(0)
      setTimeout(() => {
        setIsVisible(false)
      }, 200)
    }
  }, [playerStore.isPlayerClick])

  if (isMob) return <div className="mob">Please use pc or laptop for this app</div>
  if (!isVisible) return <></>

  return (
    <div
      style={{opacity}}
      className="home"
      onClick={() => playerStore.playerClick()
    }
    >
      <p className="home-title">Open</p>
    </div>
  )
})

export {
  HomeScreen
}